import useGet from "#hooks/useGet.js";
import { WebLayout } from "#layouts";
import ENDPOINTS from "#services/endPoints.js";
import QUERY_KEYS from "#services/queryKeys.js";
import { ContentSkelton } from "#skeleton";
import React from "react";

const TermConditions = () => {
  const { data: termsConditionData, isLoading: isTermsConditionLoading } =
    useGet(ENDPOINTS.GET_CONTENT, QUERY_KEYS.GET_CONTENT_QUERY_KEY, {
      type: 1,
    });
  return (
    <WebLayout>
      <section className="main-section spacer">
        <div className="container">
          <div className="wrapper-card h-100">
            <div className="row">
              {isTermsConditionLoading ? (
                <ContentSkelton />
              ) : (
                <div
                  className="col-xl-12"
                  dangerouslySetInnerHTML={{
                    __html: termsConditionData?.data?.content,
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </section>
    </WebLayout>
  );
};

export default TermConditions;
